export const VIRTUAL_METRIC_ADMIN_GET_LIST_INIT = 'VIRTUAL_METRIC_ADMIN_GET_LIST_INIT';
export const VIRTUAL_METRIC_ADMIN_GET_LIST_SUCCESS = 'VIRTUAL_METRIC_ADMIN_GET_LIST_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_GET_LIST_FAILURE = 'VIRTUAL_METRIC_ADMIN_GET_LIST_FAILURE';
export const VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_INIT = 'VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_INIT';
export const VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_SUCCESS = 'VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_FAILURE = 'VIRTUAL_METRIC_ADMIN_GET_DIMENSIONS_LIST_FAILURE';
export const VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_INIT = 'VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_INIT';
export const VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_SUCCESS = 'VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_FAILURE = 'VIRTUAL_METRIC_ADMIN_GET_METRICS_LIST_FAILURE';
export const VIRTUAL_METRIC_ADMIN_SAVE_INIT = 'VIRTUAL_METRIC_ADMIN_SAVE_INIT';
export const VIRTUAL_METRIC_ADMIN_SAVE_SUCCESS = 'VIRTUAL_METRIC_ADMIN_SAVE_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_SAVE_FAILURE = 'VIRTUAL_METRIC_ADMIN_SAVE_FAILURE';
export const VIRTUAL_METRIC_ADMIN_SET_SAVE_DATA_BY_KEY = 'VIRTUAL_METRIC_ADMIN_SET_SAVE_DATA_BY_KEY';
export const VIRTUAL_METRIC_ADMIN_SAVE_RESET = 'VIRTUAL_METRIC_ADMIN_SAVE_RESET';
export const VIRTUAL_METRIC_ADMIN_DELETE_PREPARE_INIT = 'VIRTUAL_METRIC_ADMIN_DELETE_PREPARE_INIT';
export const VIRTUAL_METRIC_ADMIN_DELETE_INIT = 'VIRTUAL_METRIC_ADMIN_DELETE_INIT';
export const VIRTUAL_METRIC_ADMIN_DELETE_SUCCESS = 'VIRTUAL_METRIC_ADMIN_DELETE_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_DELETE_FAILURE = 'VIRTUAL_METRIC_ADMIN_DELETE_FAILURE';
export const VIRTUAL_METRIC_ADMIN_SET_METRIC_VERSION = 'VIRTUAL_METRIC_ADMIN_SET_METRIC_VERSION';

export const VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_INIT = 'VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_INIT';
export const VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_SUCCESS = 'VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_SUCCESS';
export const VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_FAILURE = 'VIRTUAL_METRIC_ADMIN_GET_TAGS_LIST_FAILURE';

export const VIRTUAL_METRIC_ADMIN_RESET = 'VIRTUAL_METRIC_ADMIN_RESET';


// WEBPACK FOOTER //
// ./source/client/actions/virtualMetricAdmin/types.js